export function PlayRadiusIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M15.4138 10.7237C15.1361 11.8726 13.8236 12.6846 11.1986 14.3086C8.66093 15.8783 7.39226 16.6633 6.36968 16.3478C5.94694 16.2173 5.56177 15.9696 5.25115 15.6282C4.49982 14.8029 4.49982 13.2018 4.49982 9.9999C4.49982 6.79799 4.49982 5.19691 5.25115 4.37149C5.56177 4.03023 5.94694 3.7825 6.36968 3.65205C7.39226 3.33656 8.66093 4.12146 11.1986 5.69121C13.8236 7.31518 15.1361 8.12716 15.4138 9.2761C15.5284 9.75039 15.5284 10.2494 15.4138 10.7237Z" fill="black" />
    </svg>
  );
}

PlayRadiusIcon.displayName = 'PlayRadiusIcon';
